module.exports = __webpack_public_path__ + "img/20180815_151538_164.0aaf00e8.jpg";